import { QueryKey, useQuery, UseQueryOptions } from "react-query";
import { INVENTORY_ENDPOINT } from "./constants";
import useFetchWithAuth from "../fetchWithAuth";
import { useCurrentTrip } from "@/hooks";
import { Division } from "@/fetch/gworld";

type ParamsType = {
  destination: string;
  division: Division;
  status: string;
  is_public: number;
};

export type Trip = Partial<{
  id: number;
  destination_id: number;
  division_id: number;
  status: string;
  display_on_staging: number;
  division: Division;
  region_id: number;
  destination: string;
  city_id: any;
  city: string;
  region: string;
  trip_name: string;
  code: string;
  trip_link: string;
  banner_img: string;
  temp_destination: string;
  origin_currency: string;
  pricing_method: string;
  exchange_rate_date: number;
  has_origin_margin: number;
  use_exchange_rates: number;
  duration_type: string;
  partner_id: number;
  is_public: number;
  margin_type_is_fixed: number;
  staff: string;
  global_exclusive: number;
  submission_date: number;
  modified_date: number;
  trip_configs: string;
  _ca: number;
  _cb: any;
  _lma: number;
  _lmb: number;
  total_deals: any;
  accept_deposit: number;
  max_companion: any;
  min_companion: any;
  gworld_invitation: number;
  deal_expiry_date: number;
}>;

type Result = Partial<{
  success: boolean;
  statusCode: number;
  response: Array<Trip>;
}>;
type QueryError = {};

const useSearchTripsQuery = (
  options?: UseQueryOptions<Result, QueryError, Result, QueryKey>
) => {
  const { currentTrip } = useCurrentTrip();
  const tid = currentTrip?.id;
  const url = `${INVENTORY_ENDPOINT}/trips/search`;
  const cacheKey = [url];
  const { fetchWithAuth } = useFetchWithAuth();

  const params: ParamsType = {
    destination: currentTrip?.destination || "",
    division: Division.WorkingHoliday,
    status: "enabled",
    is_public: 1,
  };

  return useQuery<Result, QueryError>(
    cacheKey,
    async () => {
      if (!tid) throw new Error();
      return fetchWithAuth<Result>(url, { params: { ...params } });
    },
    {
      ...options,
    }
  );
};
export default useSearchTripsQuery;
